"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHelmet = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_helmet_1 = require("react-helmet");
const SNAPCHAT_IOS_APP_ID = "447188370";
// TODO: look at migrating to react-helmet-async; react-helmet uses react-side-effect which triggers a UNSAFE_componentWillMount warning.
// see: https://github.com/nfl/react-helmet/issues/548#issuecomment-624766504
/**
 * Renders metadata found in the document page head
 */
function PageHelmet({ title, description, snapchatDeepLinkUrl, canonicalUrl, lang, gaid, theme, preloads, preconnectOrigins, }) {
    // TODO: set dir attribute
    const validTheme = theme === "light" || theme === "dark" ? theme : "";
    const htmlAttributes = {
        prefix: "og: https://ogp.me/ns#",
        lang,
        "data-theme-override": validTheme,
    };
    return ((0, jsx_runtime_1.jsxs)(react_helmet_1.Helmet, { htmlAttributes: htmlAttributes, children: [appendTitle(title), appendDescription(description), appendiOSAppMeta(snapchatDeepLinkUrl), appendMetaViewport(), appendCanonicalUrlLink(canonicalUrl), appendGAScriptSrc(gaid), appendGAInitScript(gaid), appendGA4ScriptSrc(gaid), appendGA4InitScript(gaid), appendThemeScript(), appendFavicon(), (preloads || []).map(appendPreload), (preconnectOrigins || []).map(appendPreconnectOrigin)] }));
}
exports.PageHelmet = PageHelmet;
function appendPreconnectOrigin(origin) {
    return (0, jsx_runtime_1.jsx)("link", { rel: "preconnect", href: origin }, origin);
}
function appendTitle(title) {
    return (0, jsx_runtime_1.jsx)("title", { children: title || "Snapchat" });
}
function appendDescription(description) {
    if (description && description !== "") {
        return (0, jsx_runtime_1.jsx)("meta", { name: "description", content: description });
    }
}
// the snapchatDeepLinkUrl contains the sc_referrer query param (the canonicalUrl does not) -
// this is so that we can pass the web referrer to get the right attribution in blizzard when
// we get deeplinked into the app
function appendiOSAppMeta(appUrl) {
    const prefix = `app-id=${SNAPCHAT_IOS_APP_ID}`;
    const appContent = appUrl ? `${prefix}, app-argument=${appUrl}` : prefix;
    return (0, jsx_runtime_1.jsx)("meta", { name: "apple-itunes-app", content: appContent });
}
function appendMetaViewport() {
    return ((0, jsx_runtime_1.jsx)("meta", { name: "viewport", 
        // zooming can crash the mobile web player, so disable that
        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0" }));
}
function appendCanonicalUrlLink(canonicalUrl) {
    if (canonicalUrl && canonicalUrl !== "") {
        return (0, jsx_runtime_1.jsx)("link", { rel: "canonical", href: canonicalUrl });
    }
}
function appendGAScriptSrc(gaid) {
    if (gaid?.UAId) {
        return (0, jsx_runtime_1.jsx)("script", { async: true, src: "https://www.google-analytics.com/analytics.js" });
    }
}
function appendGAInitScript(gaid) {
    if (gaid?.UAId) {
        const src = `
    window.ga=window.ga||function(){(ga.q = ga.q || []).push(arguments)};
    ga.l=+new Date;
    ga('create','${gaid.UAId}', 'auto');
    ga('send','pageview', location.pathname);
  `;
        return (0, jsx_runtime_1.jsx)("script", { children: src });
    }
}
function appendGA4ScriptSrc(gaid) {
    if (gaid?.measurementId) {
        const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${gaid.measurementId}`;
        return (0, jsx_runtime_1.jsx)("script", { async: true, src: scriptSrc });
    }
}
function appendGA4InitScript(gaid) {
    if (gaid?.measurementId) {
        const src = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gaid.measurementId}');
  `;
        return (0, jsx_runtime_1.jsx)("script", { children: src });
    }
}
function appendThemeScript() {
    return ((0, jsx_runtime_1.jsx)("script", { children: `
      document.documentElement.setAttribute(
        "data-theme",
        document.documentElement.getAttribute("data-theme-override") ||
          (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"))
    ` }));
}
function appendFavicon() {
    return (0, jsx_runtime_1.jsx)("link", { rel: "shortcut icon", href: "https://static.snapchat.com/favicon.ico" });
}
function appendPreload(preload) {
    return (0, jsx_runtime_1.jsx)("link", { rel: "preload", ...preload }, preload.href);
}
//# sourceMappingURL=PageHelmet.js.map